import { NotificationPayload } from './NotificationPayload';
import { WorkEnvironment } from './WorkEnvironment';

export enum NotificationType {
    TaskCompleted,
    LogbookEntry,
    HistorianStorageCompleted,
    JobCompleted,
    JobFailed,
    OnlineUser
}

export interface Notification {
    creationUser: string;
    guid: string;
    isAcknowledged: boolean;
    isBroadcast: boolean;
    isVolatile: boolean;
    notificationDate: Date;
    payload?: NotificationPayload;
    type: NotificationType;
    workEnvironment: WorkEnvironment;
}